// Flip card functionality (móvil: no se cierran otras)
document.addEventListener('DOMContentLoaded', function() {
  const flipCards = document.querySelectorAll('.flip-card');

  flipCards.forEach(card => {
    const inner = card.querySelector('.flip-card-inner');
    const backClose = card.querySelector('.back-close');
    inner.addEventListener('click', function(e) {
      if (e.target.classList.contains('back-close')) { e.stopPropagation(); card.classList.remove('flipped'); return; }
      card.classList.toggle('flipped');
    });
    if (backClose) backClose.addEventListener('click', e => { e.stopPropagation(); card.classList.remove('flipped'); });
    card.addEventListener('keypress', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.classList.toggle('flipped'); } });
    card.addEventListener('keydown', e => { if (e.key === 'Escape' && card.classList.contains('flipped')) card.classList.remove('flipped'); });
    card.setAttribute('tabindex','0'); card.setAttribute('role','button'); card.setAttribute('aria-label','Click o toca para ver más información');
  });

  // ====== Desktop: igualar altura de todas las cards ======
  const mqDesktop = window.matchMedia('(min-width: 1025px)');
  function setEqualHeights(){
    const cards = document.querySelectorAll('.flip-card');
    if (!cards.length) return;
    // reset
    cards.forEach(c => c.style.removeProperty('height'));
    if (!mqDesktop.matches) return; // solo desktop
    let maxH = 0;
    cards.forEach(c => {
      const front = c.querySelector('.flip-card-front');
      const back  = c.querySelector('.flip-card-back');
      const h = Math.max(front.scrollHeight, back.scrollHeight);
      if (h > maxH) maxH = h;
    });
    // pequeño margen de seguridad
    maxH = Math.ceil(maxH + 20);
    cards.forEach(c => c.style.height = maxH + 'px');
  }
  function debounce(fn, ms){ let t; return () => { clearTimeout(t); t = setTimeout(fn, ms); }; }
  setEqualHeights();
  window.addEventListener('resize', debounce(setEqualHeights, 150));
  mqDesktop.addEventListener('change', setEqualHeights);
});
